import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getMesaByToken, getComandaByMesa } from '../services/api';
import { useCarrinho } from '../services/CarrinhoContext';
import Cardapio from './Cardapio';
import Loading from '../components/Loading';

function Mesa({ brand }) {
  const { token } = useParams();
  const { setMesa, setMesaToken, setTipoEntrega, setComanda, setComandaExistente, setUltimaComanda } = useCarrinho();
  const [mesaData, setMesaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (brand && token) {
      carregarMesa();
    }
  }, [brand, token]);

  const carregarMesa = async () => {
    try {
      setLoading(true);
      const cleanToken = token.replace(/[^a-zA-Z0-9]/g, '');
      
      // 1. Buscar dados da mesa pelo token
      const resultado = await getMesaByToken(brand, cleanToken);
      
      if (!resultado) {
        setError('Mesa não encontrada');
        return;
      }

      // 2. Setar mesa e token no context (persiste no localStorage)
      setMesaData(resultado);
      setMesa(resultado);
      setMesaToken(cleanToken);
      setTipoEntrega('local');
      
      // 3. Sempre buscar comanda ativa da mesa no backend
      // Isso garante que multiplos clientes (cenario QR code) vejam a mesma comanda
      try {
        const comandaResult = await getComandaByMesa(brand, cleanToken);
        
        if (comandaResult && comandaResult.comanda && 
            comandaResult.comanda.status !== 'fechada' && 
            comandaResult.comanda.status !== 'cancelada' &&
            comandaResult.comanda.status !== 'entregue') {
          // Comanda ativa encontrada - vincular
          setComandaExistente(comandaResult.comanda);
          setUltimaComanda(comandaResult.comanda);
          setComanda({ id: comandaResult.comanda.id });
          localStorage.setItem('sitri_ultima_comanda', JSON.stringify(comandaResult.comanda));
        } else {
          // Nenhuma comanda ativa - limpar dados antigos
          localStorage.removeItem('sitri_ultima_comanda');
          setComandaExistente(null);
          setUltimaComanda(null);
          setComanda(null);
        }
      } catch (e) {
        // Se falhar a busca de comanda, limpar para nao usar dados stale
        localStorage.removeItem('sitri_ultima_comanda');
        setComandaExistente(null);
        setUltimaComanda(null);
        setComanda(null);
      }
      
    } catch (error) {
      console.error('[Mesa] Erro ao carregar mesa:', error);
      setError('Erro ao carregar dados da mesa');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading message="Carregando mesa..." />;
  }

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-danger">
          <h4>Erro</h4>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!mesaData) {
    return <Navigate to="/" replace />;
  }

  return <Cardapio brand={brand} delivery={false} mesaData={mesaData} />;
}

export default Mesa;
